var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoice-subject" },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.invoiceSubjectData, border: "" } },
        [
          _c("el-table-column", {
            attrs: { label: "CNPJ", prop: "cnpj", "min-width": "160" },
          }),
          _c("el-table-column", {
            attrs: { prop: "ie", label: "IE", "min-width": "160" },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.stateZT"),
              prop: "status",
              "min-width": "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", size: "mini" } },
                          [_vm._v(_vm._s(_vm.$t("collectionCenter.enable")))]
                        )
                      : scope.row.status === 0
                      ? _c(
                          "el-tag",
                          { attrs: { type: "danger", size: "mini" } },
                          [_vm._v(_vm._s(_vm.$t("collectionCenter.disable")))]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { type: "info", size: "mini" } },
                          [_vm._v(_vm._s(_vm.$t("collectionCenter.Stored")))]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.businessT"),
              prop: "businessType",
              "min-width": "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.businessType === 0
                      ? _c("div", [
                          _vm._v(
                            _vm._s(_vm.$t("collectionCenter.expressDelivery"))
                          ),
                        ])
                      : _vm._e(),
                    scope.row.businessType === 1
                      ? _c("div", [
                          _vm._v(_vm._s(_vm.$t("collectionCenter.lanshou"))),
                        ])
                      : _vm._e(),
                    scope.row.businessType === 2
                      ? _c("div", [
                          _vm._v(_vm._s(_vm.$t("basicData.StockingAndPickup"))),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serviceTypes"),
              prop: "tpServ",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.zipCode"),
              prop: "zipcode",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("customerManagements.CountryCode"),
              prop: "countryCode",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.Estado"),
              prop: "state",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.city"),
              prop: "city",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.RecipientStreet"),
              prop: "street",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("placeOrder.HouseNumber"),
              prop: "number",
              "min-width": "160",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }